
import CarouselRooms from "../components/CarouselRooms";
import LittleHero from "../components/LittleHero";
import Loading from "../components/Loading";
import { useState, useEffect} from "react";
import { useGlobalContext } from "../context";

const Rooms = () => {
  const { rooms, setRooms } = useGlobalContext();
  const [loading, setLoading] = useState(true); // Stato per il caricamento delle immagini

  useEffect(() => {
    const imagePromises = rooms
      .filter((room) => room.images) // Considera solo le stanze con immagini
      .flatMap((room) => room.images)
      .map((src) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve();
          img.onerror = () => resolve(); // Se l'immagine fallisce, continua comunque
        });
      });

    Promise.all(imagePromises).then(() => setLoading(false));
  }, [rooms]);

  if (loading) {
    return <Loading />;
  }



  return (
    <>
      <LittleHero />
      <div style={{marginTop: '30px'}}>
        <CarouselRooms rooms={rooms} setRooms={setRooms} />
      </div>
    </>
  );
};

export default Rooms;

